import { DefaultTheme } from 'styled-components';
import { lightTheme } from './light';
import { darkTheme } from './dark';
import { ThemeName } from './ThemeName';

export const themes: { [K in ThemeName]: DefaultTheme } = {
  light: lightTheme,
  dark: darkTheme,
};
